import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

import Hls from 'hls.js';

@Component({

  selector: 'playlist-player',

  templateUrl: './playlist-video-player.component.html',

  styleUrls: ['./playlist-video-player.component.css']

})

export class PlaylistVideoPlayerComponent implements OnInit {

  hls!: Hls;

  currentIndex = 0;

  playlist_ = [
    "https://tempfile.shahrnik.com/1.mp4",
    "https://tempfile.shahrnik.com/2.mp4",
    "http://sample.vodobox.net/skate_phantom_flex_4k/skate_phantom_flex_4k.m3u8",
    "https://mtoczko.github.io/hls-test-streams/test-gap/playlist.m3u8",
    "https://devstreaming-cdn.apple.com/videos/streaming/examples/img_bipbop_adv_example_fmp4/master.m3u8",
  ];

  @Input() playlist!: any[]; //? لیست اصلی


  @ViewChild('videoPlayer', { static: true }) videoPlayer!: ElementRef<HTMLVideoElement>;

  ngOnInit() {

    // this.loadVideo(this.playlist[this.currentIndex]);

    this.playMp4Video(this.playlist[this.currentIndex]);

  }

  playMp4Video(url: string) {

    const player = this.videoPlayer.nativeElement;

    player.pause();

    player.src = '';

    player.load();

    // console.log('🎬 Loading MP4 video:', url);

    player.src = url;

    player.load();

    player.onloadedmetadata = () => {
      console.log('✅ MP4 metadata loaded, starting playback...');
      player.play();
    };

    player.onerror = (e) => {
      console.error('❌ MP4 playback error:', e);
    };

    player.onended = () => {
      this.currentIndex++;
      if (this.currentIndex < this.playlist.length) {
        console.log('Playing next video...');
        this.playMp4Video(this.playlist[this.currentIndex]);
      } else {
        console.log('Playlist finished.');
        //  از اول شروع کن
        // this.currentIndex = 0;
        // this.playMp4Video(this.playlist[0]);
      }
    };
    
  }

  loadVideo(url: string) {

    const player = this.videoPlayer.nativeElement;

    if (Hls.isSupported()) {

      if (this.hls) this.hls.destroy();

      this.hls = new Hls({

        maxBufferLength: 10,

        autoStartLoad: true,

        startLevel: 0,

        liveDurationInfinity: false,

        lowLatencyMode: false,

        manifestLoadingTimeOut: 20000

      });

      this.hls.loadSource(url);

      this.hls.attachMedia(player);

      this.hls.on(Hls.Events.MANIFEST_PARSED, () => {

        console.log('✅ Manifest parsed, starting playback...');

        player.play();

      });

      this.hls.on(Hls.Events.ERROR, (event, data) => {

        console.error('❌ HLS Error:', data);

      });

      player.onended = () => {

        this.currentIndex++;

        if (this.currentIndex < this.playlist.length) {

          this.loadVideo(this.playlist[this.currentIndex]);

        }

      };

    }

    else if (player.canPlayType('application/vnd.apple.mpegurl')) {

      player.src = url;

      player.addEventListener('loadedmetadata', () => {

        player.play();

      });

    }

    else {

      console.error('HLS not supported on this browser.');

    }

  }

  loadVideo_(url: string) {

    const player = this.videoPlayer.nativeElement;

    if (Hls.isSupported()) {

      if (this.hls) this.hls.destroy();

      this.hls = new Hls();

      this.hls.loadSource(url);

      this.hls.attachMedia(player);

      this.hls.on(Hls.Events.MANIFEST_PARSED, () => {

        player.play();

      });

      player.onended = () => {

        this.currentIndex++;

        if (this.currentIndex < this.playlist.length) {

          this.loadVideo(this.playlist[this.currentIndex]);

        }

      };

    }

    else if (player.canPlayType('application/vnd.apple.mpegurl')) {

      player.src = url;

      player.addEventListener('loadedmetadata', () => {

        player.play();

      });

    }

    else {

      console.error('HLS not supported on this browser.');

    }

  }

}
